import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { ianHapp } from "@/lib/celebrity-results/ian-happ";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Ian Happ Hair Transplant Results | RESTORE® Hair";
const DESC = "See Chicago Cubs All-Star Ian Happ's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "https://assets.restorehair.com/wp/2024/09/Restore_IanHapp_After_044_v3.webp";

export const Route = createFileRoute("/results/ian-happ")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/ian-happ/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/ian-happ/" },
    ],
  }),
  component: () => <CelebrityResultPage data={ianHapp} />,
});
